import React from 'react';
import SearchFilterBtn from '../../../../components/buttons/SearchFilterBtn';
import SearchFor from '../../../Modals/SearchFor';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import HeadTittle from '../../../../components/HeadTittle';
import PayrollFunctionality from './Functionality/FunctionalityPayroll';
import StepTab from "../../../../components/StepperTabs/StepTab";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import AttendanceTable from "./Subcomponents/AttendanceTable";
import {TAB_PERMISSION_ATTENDANCE, TABS_ATTENDANCE} from "./Model/Model";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {AddIcon, EditIcon, TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import ManageTab from './Manage/ManageTab';
import {permissionObj} from '../../../../Helpers/permission';
import routes from '../../../../Routes/routes';
import { ATTENDANCE_MODES } from '../../Dining/Manage/Models/Model';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Payroll = () => {

    const {
        searchElement,
        setSearchElement,
        option,
        selectedOption,
        setSimpleSearch,
        setSearch,
        contractorId,
        supplierId,
        search,
        setSendSimpleSearch,
        searchClean,
        criteria,
        setCriteria,
        filterDialogShow,
        setSelectedOption,
        finalArray,
        moduleId,
        subView,
        activeStep,
        setActiveStep,
        steps,
        setFilterDialogShow,
        setFinalArray,
        handleStepChange,
        view,
        setView,
        render,
        setRender,
        color,
        permissionButtons,
        handleUpdate,
        bodyForExport,
        setBodyForExport,
        changeSubViewManage,
        goCreate,
        selectForDelete, setSelectForDelete,
        registerAction,
        handleDelete,
        modified,
        setModified,
        handleView,
        DEV,
        permission,
        navigate
    } = PayrollFunctionality();

    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SETTING_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_READ)
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={'attendance'}>
                {permissionButtons(TAB_PERMISSION_ATTENDANCE(subView, view).EXPORT) && (
                    <>
                        {search ? (
                            <ExportDataBtn
                                id="btn_p_export"
                                moduleId={moduleId}
                                search={search}
                                option={option}
                                exportAttendance={criteria}
                            />
                        ) : (
                            <ExportDataBtn
                                id="btn_p_export"
                                moduleId={moduleId}
                                option={option}
                                search={search}
                                searchElement={searchElement}
                                body={bodyForExport}
                                exportAttendance={bodyForExport}
                            />
                        )}
                    </>
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE(subView, view).ADVANCE_SEARCH) && (
                    <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE(subView, view).CREATE) &&
                    <ButtonAction
                        id='btn_pa_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            goCreate();
                        }}
                    />
                }

                {permissionButtons(TAB_PERMISSION_ATTENDANCE(subView, view).UPDATE) && (
                    <ButtonAction
                        id='btn_pa_update'
                        name='update'
                        className='btn-icon-add'
                        disabled={false}
                        Icon={EditIcon}
                        onClick={()=>{
                            handleUpdate();
                        }}
                    />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE(subView, view).DELETE) && (
                    <ButtonAction
                        id='btn_pa_delete'
                        name='delete'
                        className='btn-icon-delete'
                        Icon={TrashOutlineIcon}
                        disabled={selectForDelete?.length == 0}
                        onClick={() => {
                            handleDelete();
                        }}
                    />
                )}

            </HeadTittle>

            <StepperTabs
                id={null}
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab normalHeight={true} index={TABS_ATTENDANCE.ATTENDANCE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.ATTENDANCE.INDEX && (
                        <AttendanceTable
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            option={option}
                            selectedOption={selectedOption}
                            setSimpleSearch={setSimpleSearch}
                            setSearch={setSearch}
                            contractorId={contractorId}
                            supplierId={supplierId}
                            search={search}
                            setSendSimpleSearch={setSendSimpleSearch}
                            searchClean={searchClean}
                            setCriteria={setCriteria}
                            setSelectedOption={setSelectedOption}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            view={view}
                            setView={setView}
                            render={render}
                            setRender={setRender}
                            color={color}
                            activeStep={activeStep}
                            modified={modified}
                            setModified={setModified}
                            handleView={handleView}
                        />
                    )}
                </StepTab>

            {/*    <StepTab index={TABS_ATTENDANCE.SUBMISSIONS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.SUBMISSIONS.INDEX && (
                        <SubmissionTab
                            subView={subView}
                            changeSubViewManage={changeSubViewManage}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            option={option}
                        />
                    )}
                </StepTab>*/}
                <StepTab index={TABS_ATTENDANCE.MANAGE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.MANAGE.INDEX && (
                        <ManageTab
                            subView={subView}
                            changeSubViewManage={changeSubViewManage}
                            registerAction={registerAction}
                            option={option}
                            selectForDelete={selectForDelete}
                            setSelectForDelete={setSelectForDelete}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                        />
                    )}
                </StepTab>
            </StepperTabs>

            <SearchFor
                open={filterDialogShow}
                onClose={() => {
                    setFilterDialogShow(false);
                }}
                onFiltered={(originalArray) => {
                    setFinalArray(originalArray);
                    setFilterDialogShow(false);
                    setSearchElement('');// Clear search input after filtering
                    setSelectedOption(ATTENDANCE_MODES.daily);
                }}
                moduleId={moduleId}
                option={option}
                finalArray={finalArray}
                search={search}
                setSearch={setSearch}
                cleanAdvance={modified}
                setCleanAdvance={setModified}
                setFinalArray={setFinalArray} // Used to reset filters
                searchElement={searchElement} // Track input changes
            />
        </>
    );
};

export default Payroll;
